const ERROR_MESSAGES = new Map([
  ['1021059', '현재 서버는 시트 탐색과 여러 시트의 컬럼 매핑 동시 사용을 지원하지 않습니다. 서버 업데이트 여부를 확인해 주세요.'],
  ['1021060', '컬럼 세팅에서 켠 시트의 이름이 비어 있거나 중복됩니다. 예시 데이터의 시트명과 컬럼 세팅의 시트명을 확인해 주세요.'],
  ['1021061', '매핑할 시트를 하나로 찾을 수 없습니다. 시트 탐색 조건을 확인하고, 탐색 결과에 예시 시트와 동일한 이름의 시트가 하나씩 있는지 확인해 주세요.'],
  ['1021062', '컬럼 매핑의 헤더 행이 올바르지 않거나 데이터 범위를 벗어났습니다. 해당 시트의 헤더 행을 다시 선택해 주세요.'],
  ['1021063', '매핑할 원본 헤더가 비어 있거나 입력 데이터에 없습니다. 각 시트의 컬럼 매핑을 다시 설정해 주세요.'],
])

export function getInputFindSheetErrorMessage(payload) {
  function visit(value, depth = 0) {
    if (value == null || depth > 6) return ''
    if (typeof value === 'string') {
      // Some execution responses serialize their structured error as JSON.
      if (!/^[\s]*[{[]/.test(value)) return ''
      try { return visit(JSON.parse(value), depth + 1) } catch { return '' }
    }
    if (typeof value !== 'object') return ''
    const message = ERROR_MESSAGES.get(String(value.err_code))
    if (message) return message
    // Preview serializer errors and runtime failures use different envelopes.
    const nested = Array.isArray(value) ? value : [value.mapping_mode, value.error, value.detail]
    for (const item of nested) {
      const result = visit(item, depth + 1)
      if (result) return result
    }
    return ''
  }
  return visit(payload)
}
